import React, { createContext, useContext, useState, useEffect } from 'react';

interface PageInfo {
  title: string;
  description?: string;
}

interface PageContextType {
  pageInfo: PageInfo;
  setPageInfo: (info: PageInfo) => void;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

export function PageProvider({ children }: { children: React.ReactNode }) {
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    title: 'AK Ahamed',
    description: undefined
  });

  return (
    <PageContext.Provider value={{ pageInfo, setPageInfo }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePageInfo() {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageInfo must be used within PageProvider');
  }
  return context;
}

// Hook to set page info
export function useSetPageInfo(title: string, description?: string) {
  const { setPageInfo } = usePageInfo();
  
  useEffect(() => {
    setPageInfo({ title, description });
    
    // Reset on unmount
    return () => {
      setPageInfo({ title: 'AK Ahamed', description: undefined });
    };
  }, [title, description, setPageInfo]);
}